define(function(require){
	'use strict';

	var Marionette = require('marionette');
    var Backbone = require('backbone');
	var Model = require('models/crater_step');
    var AppConfig = require('config/application');

    var LPTCollection = require('vendor/Backbone/LPTCollection');

	return Backbone.Collection.extend({
        model: Model,
            // Sync url
        url : AppConfig.host + '/rest/funnel/stages',
        parse: function (response) {
            if (response.result !== undefined) {
                return response.result.data;
            } else {
                return response;
            }
        },


        comparator: function (model) {
            return model.get('order');
        },

            /*
            *   function comparator()
            *   Get model order parameter
            *   @param  {Backbone.Model}    model
            *   @return {int}               order
            */
            // comparator: function(model){
            //     return model.get('order');
            // },

            /*
            *   function nextOrder()
            *   Generate order parameter for model
            *   @param  {string}    list (temp|crater)
            *   @return {int}       order
            */
            nextOrder: function(list){
                if(!this.length){
                    return 1;
                }

                var ret;
                var items = this.where({ list: list });
                if(!items.length || items.length == 0){
                    return 1;
                }
                var len  = items.length;
                var last = items[ len - 1 ];

                if(list == 'crater'){
                    if(len == 1){
                        last.set('order', 2);
                        ret = 1;
                    }else{
                        var order = last.get('order');
                        last.set('order', order+1);
                        ret = order;
                    }
                }else{
                    ret = last.get('order') + 1;
                }
                return ret;
            }

            /*
            *   function parse()
            *   Parse server response when sync
            *   @param  {mixed} response
            *   @return {json}  result
            */
            // parse: function(response){
            //     if(response.result !== undefined){
            //         return response.result.data;
            //     }else{
            //         return response;
            //     }
            // }
        });
});
